<template>
  <div class="container">
    <!-- <div> -->
    <div id="silderLeft">
      <div class="menu-wrapper">
        <tree-menu
          :modulesConfig="modulesConfig"
          ref="tree"
          @menu-click="handleMenuClick"
          :processType="processType"
          @initRight="iframeClickIndex = 0"
        ></tree-menu>
      </div>
      <div class="moveBtn" v-move></div>
    </div>
    <div id="silderRight">
      <div class="sheet-content" :style="`background:${iframeClickIndex ? 'none' : '#ffffff'}`">
        <file-management
          ref="management"
          v-if="iframeClickIndex"
          style="width: 100%; height: 100%"
          :folderPath="folderPath"
          @expandNodeById="expandNodeById"
          @getNewTree="getNewTree"
        ></file-management>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import 'element-ui/lib/theme-chalk/base.css';
import treeMenu from './treeMenu/treeMenu';
import fileManagement from './common/fileManagement';
export default {
  name: 'shortVideoManagement',
  props: ['processType'],
  directives: {
    move(el, bindings) {
      el.onmousedown = function (e) {
        var init = e.clientX;
        var left = document.getElementById('silderLeft');
        var right = document.getElementById('silderRight');
        var initWidth = left.offsetWidth;
        document.onmousemove = function (e) {
          let et = e || window.event;
          et.preventDefault();
          var end = e.clientX;
          // end - init表示鼠标移动的距离
          // end为鼠标移动的宽度,可用于设置最小宽度
          if (end > 880) {
            var newWidth = 730;
            left.style.width = newWidth + 'px';
            right.style.width = `calc(100% - ${newWidth}px )`;
          } else if (end > 404) {
            var newWidth = end - init + initWidth;
            left.style.width = newWidth + 'px';
            right.style.width = `calc(100% - ${newWidth}px )`;
          } else {
            left.style.width = 250 + 'px';
          }
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      };
    },
  },
  components: { treeMenu, fileManagement },
  data() {
    return {
      modulesConfig: {
        appCode: 'e-commerce',
        subAppCode: 'ec-pc-api',
      },
      collapse: true,
      iframeSrc: '',
      iframeClickIndex: 0,
      folderPath: '',
    };
  },
  watch: {
    // iframeSrc(val,old) {
    //   if(!val.includes('fileManagement')) {
    //     this.iframeSrc = old
    //   }
    // }
  },
  mounted() {},
  methods: {
    handleMenuClick(p, folderPath) {
      this.folderPath = folderPath;
      this.iframeClickIndex += 1;
      this.iframeSrc = p;
      var iframe_home = this.$refs.management;
      if (this.iframeClickIndex != 1) {
        setTimeout(() => {
          this.$refs.management.resetTableSort();
          this.$refs.management.onSearch(p.id);
          this.$refs.management.fliePath = p.path;
          // iframe_home.contentWindow.resizeWindow()
        }, 500);
      } else {
        setTimeout(() => {
          var iframe_home = this.$refs.management;
          if (iframe_home) {
            this.$refs.management.resetTableSort();
            this.$refs.management.onSearch(p.id);
            this.$refs.management.fliePath = p.path;
            // iframe_home.contentWindow.resizeWindow()
          }
        }, 3000);
      }
    },
    //文件夹类型点击下一层级时左侧树形节点打开
    expandNodeById(id) {
      this.$refs.tree.expandNodeById(id);
    },
    //删除文件夹时更新左侧树形数据
    getNewTree(id) {
      this.$refs.tree.get_menu(id);
    },
  },
};
</script>

<style lang="stylus" scoped>
.container
  padding 5px
  height calc(100vh - 119px)
  width 100%
  background: #A6CDBC
  box-sizing border-box
  position relative
  display flex

#silderRight
  height: 100%
  flex: 1
  padding-left: 5px;
  overflow hidden

#silderLeft
  position: relative;
  width 250px

.moveBtn
  width 5px
  height 100%
  position: absolute;
  right: 0px;
  top: 0;
  cursor: col-resize;

.menu-wrapper
  width 100%
  height 100%
  background #ffffff
  border-radius 5px
  position relative
  padding-top 0.1px
  box-sizing border-box
.sheet-content
  width 100%
  height 100%
  // background #ffffff
  border-radius 5px
  padding-top 0.1px
  box-sizing border-box
  overflow hidden
  position relative
  .iframe
    position absolute
    right 0
    bottom 0
    z-index 999

.slide-btn
  cursor pointer
  width 50px
  height 50px
  background rgb(31,173,128)
  text-align center
  line-height 58px
  position absolute
  left 220px
  top 20px
  z-index 1000
  transition all cubic-bezier(.72,.01,.13,1) .6s
>>> .el-icon-back
  color #ffffff
  font-size 24px
  transition all linear .4s

.collapsed
  transform translate(-220px, 0)
.rotated
  transform rotate(540deg)
</style>
